import { render, staticRenderFns } from "./ChannelBrowser.vue?vue&type=template&id=3bedee68&lang=pug&"
import script from "./ChannelBrowser.vue?vue&type=script&lang=js&"
export * from "./ChannelBrowser.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBrowser.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports